import React from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { ManifestoSection } from './components/ManifestoSection';
import { EditorialSplit } from './components/EditorialSplit';
import { ImpactBanner } from './components/ImpactBanner';
import { ServiciosSection } from './components/ServiciosSection';
import { FAQSection } from './components/FAQSection';
import { ContactForm } from './components/ContactForm';
import { FooterSection } from './components/FooterSection';
export function App() {
  return <main className="relative w-full min-h-screen selection:bg-forest selection:text-cream font-serif" data-id="element-0">
      {/* Fixed Floral Background */}
      <div className="fixed inset-0 z-[-1]" style={{
      backgroundImage: 'url("https://cdn.magicpatterns.com/uploads/pJcYgKKje25XErXZcAEnDT/fondo.jpg")',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat'
    }} data-id="element-1" />

      <Navbar data-id="element-2" />
      <HeroSection data-id="element-3" />
      <ManifestoSection data-id="element-4" />
      <EditorialSplit data-id="element-5" />
      <ImpactBanner data-id="element-6" />
      <ServiciosSection data-id="element-7" />
      <FAQSection data-id="element-8" />
      <ContactForm data-id="element-9" />
      <FooterSection data-id="element-10" />
    </main>;
}